import React from 'react';
import Hero from '../components/sections/Hero';
import LatestCollection from '../components/sections/LatestCollection';
import About from '../components/sections/About';
import Collections from '../components/sections/Collections';
import Contact from '../components/sections/Contact';

const HomePage = () => {
  return (
    <>
      <Hero />
      <LatestCollection />
      <About />
      <Collections />
      <Contact />
    </>
  );
};

export default HomePage;

